import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export function specialCharactersValidator(minimumSpecialCharacters: number): ValidatorFn {
   return (c: AbstractControl): { [Key: string]: boolean } | null => {
      const pattern = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
      let specialCharacterCount = 0;
      if (c.value != null) {
         const value: string = c.value;
         for (let i = 0; i < value.length; i++) {
            if (pattern.test(value[i])) {
               specialCharacterCount++;
            }
         }
         if (specialCharacterCount < minimumSpecialCharacters) {
            return { specialcharacters: true };
         }
      }
      return null;
   };
}

export function upperCaseCharactersValidator(minimumUpperCaseCharacters: number): ValidatorFn {
   return (c: AbstractControl): { [Key: string]: boolean } | null => {
      const pattern = /^[A-Z]*$/;
      let upperCaseCharacterCount = 0;
      if (c.value != null) {
         const value: string = c.value;
         for (let i = 0; i < value.length; i++) {
            if (pattern.test(value[i])) {
               upperCaseCharacterCount++;
            }
         }
         if (upperCaseCharacterCount < minimumUpperCaseCharacters) {
            return { uppercasecharacters: true };
         }
      }
      return null;
   };
}

export function numericCharactersValidator(minimumNumericCharacters: number): ValidatorFn {
   return (c: AbstractControl): { [Key: string]: boolean } | null => {
      const pattern = /^[0-9]*$/;
      let numericCharacterCount = 0;
      if (c.value != null) {
         const value: string = c.value;
         for (let i = 0; i < value.length; i++) {
            if (pattern.test(value[i])) {
               numericCharacterCount++;
            }
         }
         if (numericCharacterCount < minimumNumericCharacters) {
            return { numericcharacters: true };
         }
      }
      return null;
   };
}

export function sipPasswordValidators(): ValidatorFn[] {
   return [
      Validators.minLength(8),
      upperCaseCharactersValidator(1),
      specialCharactersValidator(1),
      numericCharactersValidator(1),
   ];
}
